import { render, staticRenderFns } from "./ApplicantCBT.vue?vue&type=template&id=027695d5&scoped=true"
import script from "./ApplicantCBT.vue?vue&type=script&lang=js"
export * from "./ApplicantCBT.vue?vue&type=script&lang=js"
import style0 from "./ApplicantCBT.vue?vue&type=style&index=0&id=027695d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027695d5",
  null
  
)

export default component.exports